const isDevMode = true;

export class MyLog {
  static showLog(message: any): void {
    if (isDevMode) console.info(message);
  }
}
